import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '../../../context/DataContext';
import './causes.css';
import { Button } from '../../common/Button';
import { BottomNav } from '../../common/BottomNav';
import { FeedbackLink } from '../../common/FeedbackLink';

const causesData = [
  {
    id: 'homelessness',
    title: 'Homelessness Awareness',
    description: 'Track outreach, resource sharing, and policy advocacy to address homelessness.',
    icon: '/images/cause_homeless_awareness.png',
  },
  {
    id: 'beautification',
    title: 'Community Beautification',
    description: 'Participate in cleanup efforts, public space improvements, and local projects.',
    icon: '/images/cause_comunity_beautification.png',
  },
  {
    id: 'trafficking',
    title: 'Human Trafficking Awareness',
    description: 'Combat trafficking through education, reporting mechanisms, and support.',
    icon: '/images/cause_human_traffic.png',
  },
];

export const CausesScreen = () => {
  const [selectedCauses, setSelectedCauses] = useState([]);
  const navigate = useNavigate();
  const { causes: existingCauses } = useContext(DataContext);

  const availableCauses = causesData.filter(
    (cause) => !existingCauses.some((existing) => existing.id === cause.id)
  );

  const toggleCause = (causeId) => {
    setSelectedCauses((prevSelected) => {
      if (prevSelected.includes(causeId)) {
        return prevSelected.filter((id) => id !== causeId);
      } else {
        if (prevSelected.length < 3) {
          return [...prevSelected, causeId];
        }
        return prevSelected;
      }
    });
  };

  const handleContinue = () => {
    const selectedCauseData = selectedCauses.map(id => causesData.find(cause => cause.id === id));
    navigate('/level-selection', { state: { causes: selectedCauseData } });
  };

  return (
    <div className="causes-screen">
      <header className="progress-header">
        <button className="back-button" onClick={() => window.history.back()}>←</button>
        <h1>Cause Selection</h1>
      </header>
      <main>
        {availableCauses.length === 0 ? (
          <div className="no-causes-available">
            <p className="causes-subtitle">You've already joined all available causes!</p>
            <p className="causes-footer-text">You can manage your causes from the home screen.</p>
            <Button onClick={() => navigate('/home')} className="continue-button">Go to Home</Button>
          </div>
        ) : (
          <>
            <p className="causes-subtitle">Choose one or more causes you care about:</p>
            <div className="causes-list">
              {availableCauses.map((cause) => (
                <div
                  key={cause.id}
                  className={`cause-card ${selectedCauses.includes(cause.id) ? 'selected' : ''}`}
                  onClick={() => toggleCause(cause.id)}
                >
                  <img src={cause.icon} alt="" className="cause-icon" />
                  <div className="cause-info">
                    <h2>{cause.title}</h2>
                    <p>{cause.description}</p>
                  </div>
                  <div className="cause-selector">
                    <div className="radio-button"></div>
                  </div>
                </div>
              ))}
            </div>
            <p className="causes-footer-text">You can add or remove causes later from the home screen.</p>
            <Button onClick={handleContinue} className="continue-button" disabled={selectedCauses.length === 0}>Continue</Button>
          </>
        )}
      </main>
      <FeedbackLink />
      <BottomNav />
    </div>
  );
};
